import rem from '@/utils/rem';
import { isArray } from "lodash"
import PropTypes from "prop-types";
import Modal, { MEDIUM_MODAL_WIDTH } from "@/dsComponents/Modal";
import { ModalBody, ModalFooter, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import { ErrorOutlineOutlined } from "@dextech-ai/dex-design-system/icons";
import ModalSelectedList from '@/components/ModalSelectedList/index';

const AgentPersonaModal = ({ visible, hide, handleSubmission, header, body, dataItems, ["data-testid"]: dataTest }) => {
	return (
		<div data-testid={dataTest}>
			<Modal width={MEDIUM_MODAL_WIDTH} visible={visible} close={hide}>
				<ModalHeader icon={<ErrorOutlineOutlined color="error" />}>
					<ModalTitle>{header}</ModalTitle>
				</ModalHeader>
				<ModalBody>
					<div data-testid={`${dataTest}-confirm-remove-persona-content`}>
						{isArray(body) && body.length !== 1 ? body.map((item, index) => {
							let style = index === 0 ? "data-table__table__head__row" : null
							return (<div className="data-table__table__head" key={index}>
								<div className={style} style={{ textAlign: "center", paddingBlock: "20px" }}>
									{item}
								</div>
							</div>
							)
						}) :
							<div style={{ textAlign: 'center', paddingBlock: "24px" }}>
								{body[0]}
							</div>
						}
						<br />
						{
							dataItems && (
								<ModalSelectedList
									items={dataItems.filter(item => item.organizationPersonaId !== undefined && item.$selected === false)}
									title="Selected Persona(s)"
									valueKey="name"
								/>
							)
						}
					</div>
				</ModalBody>
				<ModalFooter>
					<ModalFooterRight>
						<button data-testid={`${dataTest}-cancel-remove-persona-button`} className="button--ghost" style={{ width: rem(80) }}
							onClick={() => {
								hide()
							}}
						>Cancel</button>
						<button data-testid={`${dataTest}-confirm-button`} style={{ width: rem(80), marginLeft: rem(10) }}
							onClick={() => {
								handleSubmission()
								hide()
							}}
						>Confirm</button>
					</ModalFooterRight>
				</ModalFooter>
			</Modal>
		</div>
	)
}

AgentPersonaModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	hide: PropTypes.func.isRequired,
	handleSubmission: PropTypes.func.isRequired,
	header: PropTypes.string.isRequired,
	body: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string)
	]).isRequired,
	dataItems: PropTypes.array,
	"data-testid": PropTypes.string
};


export default AgentPersonaModal
